/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAggregatedResult = /* GraphQL */ `query GetAggregatedResult(
  $openSearchIndex: String!
  $groupByText: [String!]
  $groupByNumeric: [String!]
  $filter: String
  $limit: Int
  $nextToken: String
  $from: Int
) {
  getAggregatedResult(
    openSearchIndex: $openSearchIndex
    groupByText: $groupByText
    groupByNumeric: $groupByNumeric
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    from: $from
  ) {
    items {
      key
      doc_count
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAggregatedResultQueryVariables,
  APITypes.GetAggregatedResultQuery
>;
export const getBLConcurrencyLock = /* GraphQL */ `query GetBLConcurrencyLock($community: ID!) {
  getBLConcurrencyLock(community: $community) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBLConcurrencyLockQueryVariables,
  APITypes.GetBLConcurrencyLockQuery
>;
export const listBLConcurrencyLocks = /* GraphQL */ `query ListBLConcurrencyLocks(
  $community: ID
  $filter: ModelBLConcurrencyLockFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBLConcurrencyLocks(
    community: $community
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      community
      lockToken
      createdAt
      expirationUnixTime
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBLConcurrencyLocksQueryVariables,
  APITypes.ListBLConcurrencyLocksQuery
>;
export const getBoughtList = /* GraphQL */ `query GetBoughtList($id: ID!) {
  getBoughtList(id: $id) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBoughtListQueryVariables,
  APITypes.GetBoughtListQuery
>;
export const listBoughtLists = /* GraphQL */ `query ListBoughtLists(
  $filter: ModelBoughtListFilterInput
  $limit: Int
  $nextToken: String
) {
  listBoughtLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      saluation
      firstName
      lastName
      gender
      age
      address
      city
      state
      zipcode
      county
      householdIncome
      householdIncomeBottom
      householdIncomeTop
      homeValue
      homeValueBottom
      homeValueTop
      boatingSailing
      tennis
      golf
      boatOwner
      upscaleLiving
      suppress
      doNotMail
      dropDate
      zip5
      batchCode
      listDate
      listName
      listNameId
      qseq
      expirationDate
      lastUpdated
      site1
      siteDistance1
      epm3Decile1
      epm3Score1
      epm3Tier1
      site2
      siteDistance2
      epm3Decile2
      epm3Score2
      epm3Tier2
      blSelect
      hlMatch
      randomNumber
      randomFlag
      netNewFlag
      staticControlFlag
      hlGrpRowList
      hlODateList
      optOut
      optOutDateTime
      optOutUpdatedBy
      createdAt
      updatedAt
      expirationUnixTime
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBoughtListsQueryVariables,
  APITypes.ListBoughtListsQuery
>;
export const searchBoughtLists = /* GraphQL */ `query SearchBoughtLists(
  $filter: SearchableBoughtListFilterInput
  $sort: [SearchableBoughtListSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableBoughtListAggregationInput]
) {
  searchBoughtLists(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      saluation
      firstName
      lastName
      gender
      age
      address
      city
      state
      zipcode
      county
      householdIncome
      householdIncomeBottom
      householdIncomeTop
      homeValue
      homeValueBottom
      homeValueTop
      boatingSailing
      tennis
      golf
      boatOwner
      upscaleLiving
      suppress
      doNotMail
      dropDate
      zip5
      batchCode
      listDate
      listName
      listNameId
      qseq
      expirationDate
      lastUpdated
      site1
      siteDistance1
      epm3Decile1
      epm3Score1
      epm3Tier1
      site2
      siteDistance2
      epm3Decile2
      epm3Score2
      epm3Tier2
      blSelect
      hlMatch
      randomNumber
      randomFlag
      netNewFlag
      staticControlFlag
      hlGrpRowList
      hlODateList
      optOut
      optOutDateTime
      optOutUpdatedBy
      createdAt
      updatedAt
      expirationUnixTime
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchBoughtListsQueryVariables,
  APITypes.SearchBoughtListsQuery
>;
export const getUserFilter = /* GraphQL */ `query GetUserFilter($id: ID!) {
  getUserFilter(id: $id) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserFilterQueryVariables,
  APITypes.GetUserFilterQuery
>;
export const listUserFilters = /* GraphQL */ `query ListUserFilters(
  $filter: ModelUserFilterFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserFilters(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      listType
      name
      filterDefinitions
      filterSelections
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserFiltersQueryVariables,
  APITypes.ListUserFiltersQuery
>;
export const searchUserFilters = /* GraphQL */ `query SearchUserFilters(
  $filter: SearchableUserFilterFilterInput
  $sort: [SearchableUserFilterSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableUserFilterAggregationInput]
) {
  searchUserFilters(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      listType
      name
      filterDefinitions
      filterSelections
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchUserFiltersQueryVariables,
  APITypes.SearchUserFiltersQuery
>;
export const getExportJob = /* GraphQL */ `query GetExportJob($id: ID!) {
  getExportJob(id: $id) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExportJobQueryVariables,
  APITypes.GetExportJobQuery
>;
export const listExportJobs = /* GraphQL */ `query ListExportJobs(
  $filter: ModelExportJobFilterInput
  $limit: Int
  $nextToken: String
) {
  listExportJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      exportName
      listType
      reportId
      status
      statusMessage
      filterInput
      filterFields
      outputFormat
      s3Key
      totalRecords
      fileSize
      startedAt
      expiresAt
      createdAt
      updatedAt
      owner
      authorizedReaders
      debugInfo
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExportJobsQueryVariables,
  APITypes.ListExportJobsQuery
>;
export const searchExportJobs = /* GraphQL */ `query SearchExportJobs(
  $filter: SearchableExportJobFilterInput
  $sort: [SearchableExportJobSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableExportJobAggregationInput]
) {
  searchExportJobs(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      exportName
      listType
      reportId
      status
      statusMessage
      filterInput
      filterFields
      outputFormat
      s3Key
      totalRecords
      fileSize
      startedAt
      expiresAt
      createdAt
      updatedAt
      owner
      authorizedReaders
      debugInfo
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchExportJobsQueryVariables,
  APITypes.SearchExportJobsQuery
>;
export const getReportRunSchedule = /* GraphQL */ `query GetReportRunSchedule($id: ID!) {
  getReportRunSchedule(id: $id) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetReportRunScheduleQueryVariables,
  APITypes.GetReportRunScheduleQuery
>;
export const listReportRunSchedules = /* GraphQL */ `query ListReportRunSchedules(
  $id: ID
  $filter: ModelReportRunScheduleFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReportRunSchedules(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      reportId
      scheduleExpression
      enabled
      subscribers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportRunSchedulesQueryVariables,
  APITypes.ListReportRunSchedulesQuery
>;
export const reportRunSchedulesByReportId = /* GraphQL */ `query ReportRunSchedulesByReportId(
  $reportId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelReportRunScheduleFilterInput
  $limit: Int
  $nextToken: String
) {
  reportRunSchedulesByReportId(
    reportId: $reportId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      reportId
      scheduleExpression
      enabled
      subscribers
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ReportRunSchedulesByReportIdQueryVariables,
  APITypes.ReportRunSchedulesByReportIdQuery
>;
export const getHouselistNew = /* GraphQL */ `query GetHouselistNew($id: ID!) {
  getHouselistNew(id: $id) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHouselistNewQueryVariables,
  APITypes.GetHouselistNewQuery
>;
export const listHouselistNews = /* GraphQL */ `query ListHouselistNews(
  $filter: ModelHouselistNewFilterInput
  $limit: Int
  $nextToken: String
) {
  listHouselistNews(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      accountID
      listName
      listNameId
      control
      homeValue
      homeValueBottom
      homeValueTop
      hohIncome
      hohIncomeBottom
      hohIncomeTop
      hohNetWorth
      hohNetWorthBottom
      hohNetWorthTop
      groupName
      birthDate
      deceasedDate
      distanceToSite
      doNotCall
      email
      emailBounceDate
      epm2Grade
      epm2Score
      epm2Tier
      firstName
      gender
      hasOptedOutOfEmail
      hohAge
      homePhone
      contactId
      ilContactStatus
      labelSalutation
      lastName
      letterSalutation
      neighborhood
      city
      zip5
      zipcode
      state
      address
      maritalStatus
      mlActive
      cellPhone
      primaryContact
      primarySite
      latitude
      longitude
      qasValidationStatus
      contactType
      returnedMail
      ccContactStatus
      opportunitySite
      opportunityId
      loc
      ltsGrade
      ltsScore
      primaryMotivation
      communityName
      rating
      segmentation
      settledDate
      salesStage
      priorityDate
      reservationDate
      businessType
      salesOptionDate
      apartmentName
      optOut
      optOutDateTime
      mlContactInactiveReasons
      mlSOInactiveReasons
      mlInactiveReasons
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHouselistNewsQueryVariables,
  APITypes.ListHouselistNewsQuery
>;
export const searchHouselistNews = /* GraphQL */ `query SearchHouselistNews(
  $filter: SearchableHouselistNewFilterInput
  $sort: [SearchableHouselistNewSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableHouselistNewAggregationInput]
) {
  searchHouselistNews(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      accountID
      listName
      listNameId
      control
      homeValue
      homeValueBottom
      homeValueTop
      hohIncome
      hohIncomeBottom
      hohIncomeTop
      hohNetWorth
      hohNetWorthBottom
      hohNetWorthTop
      groupName
      birthDate
      deceasedDate
      distanceToSite
      doNotCall
      email
      emailBounceDate
      epm2Grade
      epm2Score
      epm2Tier
      firstName
      gender
      hasOptedOutOfEmail
      hohAge
      homePhone
      contactId
      ilContactStatus
      labelSalutation
      lastName
      letterSalutation
      neighborhood
      city
      zip5
      zipcode
      state
      address
      maritalStatus
      mlActive
      cellPhone
      primaryContact
      primarySite
      latitude
      longitude
      qasValidationStatus
      contactType
      returnedMail
      ccContactStatus
      opportunitySite
      opportunityId
      loc
      ltsGrade
      ltsScore
      primaryMotivation
      communityName
      rating
      segmentation
      settledDate
      salesStage
      priorityDate
      reservationDate
      businessType
      salesOptionDate
      apartmentName
      optOut
      optOutDateTime
      mlContactInactiveReasons
      mlSOInactiveReasons
      mlInactiveReasons
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchHouselistNewsQueryVariables,
  APITypes.SearchHouselistNewsQuery
>;
export const getAccount = /* GraphQL */ `query GetAccount($id: ID!) {
  getAccount(id: $id) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAccountQueryVariables,
  APITypes.GetAccountQuery
>;
export const listAccounts = /* GraphQL */ `query ListAccounts(
  $filter: ModelAccountFilterInput
  $limit: Int
  $nextToken: String
) {
  listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      updateHash
      accountID
      isDeleted
      labelSaluation
      homeValueBottom
      accountNameId
      homeValueTop
      letterSaluation
      numberOfParticipants
      primaryContact
      lastModifiedDate
      otherInterestsMotivation
      createdDate
      controlFlag
      hobbiesInterest
      primarySite
      hohNetRange
      homeValueRange
      hohNetWorthTop
      hohIncomeRange
      hohIncomeBottom
      accountName
      hohIncomeTop
      hohNetWorthBottom
      parentAccountID
      returnedMail
      type
      id
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAccountsQueryVariables,
  APITypes.ListAccountsQuery
>;
export const getContact = /* GraphQL */ `query GetContact($id: ID!) {
  getContact(id: $id) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContactQueryVariables,
  APITypes.GetContactQuery
>;
export const listContacts = /* GraphQL */ `query ListContacts(
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      doNotMail
      deceasedDate
      birthDate
      lastName
      status
      emailBounceBack
      isDeleted
      labelSaluation
      homeValueBottom
      letterSaluation
      hohNetWorth
      contactID
      hohAge
      primaryFlag
      lastModifiedDate
      mailingStreet
      mailingState
      preferredContactMethod
      epm2Score
      ilContactStatus
      emailBounceBackDate
      fullName
      primarySite
      homeValueRange
      maritalStatus
      mailingCountry
      militaryService
      hohIncomeRange
      hohIncomeBottom
      hohIncomeTop
      qasLongitude
      hasOptedOutOfEmail
      mailingCountryCode
      returnedMail
      mobilePhone
      accountID
      qasMailingValidationStatus
      email
      homeValueTop
      firstName
      mailingCity
      doNotCall
      salutation
      mlActive
      homePhone
      placeOfBirth
      masterRecordID
      emailOptOutDate
      gender
      qasLatitude
      hohNetWorthTop
      mailingZipCode
      mailingNeighborhood
      contactType
      hohNetWorthBottom
      epm2Decile
      mailingStateCode
      id
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContactsQueryVariables,
  APITypes.ListContactsQuery
>;
export const getSalesOption = /* GraphQL */ `query GetSalesOption($id: ID!) {
  getSalesOption(id: $id) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSalesOptionQueryVariables,
  APITypes.GetSalesOptionQuery
>;
export const listSalesOptions = /* GraphQL */ `query ListSalesOptions(
  $filter: ModelSalesOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listSalesOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      lossReason
      createdDate
      accountID
      apartment
      apartmentName
      rating
      community
      settledDate
      requestedMailOfBrochure
      isDeleted
      sourceID
      reservationDate
      reservedMSP
      salesOptionName
      priorityDepCommunity
      ltsScore
      ltsGrade
      lastModifiedDate
      campaignID
      priorityDate
      segmentation
      levelOfCare
      mergeFlag
      id
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSalesOptionsQueryVariables,
  APITypes.ListSalesOptionsQuery
>;
export const getStaffSeed = /* GraphQL */ `query GetStaffSeed($id: ID!) {
  getStaffSeed(id: $id) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStaffSeedQueryVariables,
  APITypes.GetStaffSeedQuery
>;
export const listStaffSeeds = /* GraphQL */ `query ListStaffSeeds(
  $filter: ModelStaffSeedFilterInput
  $limit: Int
  $nextToken: String
) {
  listStaffSeeds(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      address
      city
      community
      createdby
      email
      firstName
      labelSalutation
      lastModifiedBy
      lastName
      letterSalutation
      loc
      owner
      postalCode
      seedDataName
      state
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStaffSeedsQueryVariables,
  APITypes.ListStaffSeedsQuery
>;
export const searchStaffSeeds = /* GraphQL */ `query SearchStaffSeeds(
  $filter: SearchableStaffSeedFilterInput
  $sort: [SearchableStaffSeedSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableStaffSeedAggregationInput]
) {
  searchStaffSeeds(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      address
      city
      community
      createdby
      email
      firstName
      labelSalutation
      lastModifiedBy
      lastName
      letterSalutation
      loc
      owner
      postalCode
      seedDataName
      state
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchStaffSeedsQueryVariables,
  APITypes.SearchStaffSeedsQuery
>;
export const getDistanceToSite = /* GraphQL */ `query GetDistanceToSite($id: ID!) {
  getDistanceToSite(id: $id) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDistanceToSiteQueryVariables,
  APITypes.GetDistanceToSiteQuery
>;
export const listDistanceToSites = /* GraphQL */ `query ListDistanceToSites(
  $filter: ModelDistanceToSiteFilterInput
  $limit: Int
  $nextToken: String
) {
  listDistanceToSites(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      distanceToSiteId
      distance
      site
      communityId
      createdDate
      isDeleted
      lastModifiedDate
      contactId
      name
      id
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDistanceToSitesQueryVariables,
  APITypes.ListDistanceToSitesQuery
>;
export const getFilterValue = /* GraphQL */ `query GetFilterValue($id: ID!) {
  getFilterValue(id: $id) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFilterValueQueryVariables,
  APITypes.GetFilterValueQuery
>;
export const listFilterValues = /* GraphQL */ `query ListFilterValues(
  $filter: ModelFilterValueFilterInput
  $limit: Int
  $nextToken: String
) {
  listFilterValues(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      listType
      fieldId
      version
      selectedValues
      relationalOperator
      description
      changeReason
      changedBy
      id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFilterValuesQueryVariables,
  APITypes.ListFilterValuesQuery
>;
export const searchFilterValues = /* GraphQL */ `query SearchFilterValues(
  $filter: SearchableFilterValueFilterInput
  $sort: [SearchableFilterValueSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFilterValueAggregationInput]
) {
  searchFilterValues(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      listType
      fieldId
      version
      selectedValues
      relationalOperator
      description
      changeReason
      changedBy
      id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFilterValuesQueryVariables,
  APITypes.SearchFilterValuesQuery
>;
export const getFlagDefinition = /* GraphQL */ `query GetFlagDefinition($id: ID!) {
  getFlagDefinition(id: $id) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFlagDefinitionQueryVariables,
  APITypes.GetFlagDefinitionQuery
>;
export const listFlagDefinitions = /* GraphQL */ `query ListFlagDefinitions(
  $filter: ModelFlagDefinitionFilterInput
  $limit: Int
  $nextToken: String
) {
  listFlagDefinitions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      listType
      fieldName
      flagValue
      friendlyName
      description
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListFlagDefinitionsQueryVariables,
  APITypes.ListFlagDefinitionsQuery
>;
export const searchFlagDefinitions = /* GraphQL */ `query SearchFlagDefinitions(
  $filter: SearchableFlagDefinitionFilterInput
  $sort: [SearchableFlagDefinitionSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableFlagDefinitionAggregationInput]
) {
  searchFlagDefinitions(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      listType
      fieldName
      flagValue
      friendlyName
      description
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchFlagDefinitionsQueryVariables,
  APITypes.SearchFlagDefinitionsQuery
>;
export const getDataTransferStage = /* GraphQL */ `query GetDataTransferStage($id: ID!) {
  getDataTransferStage(id: $id) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDataTransferStageQueryVariables,
  APITypes.GetDataTransferStageQuery
>;
export const listDataTransferStages = /* GraphQL */ `query ListDataTransferStages(
  $id: ID
  $filter: ModelDataTransferStageFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDataTransferStages(
    id: $id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      id
      traceId
      fileKey
      totalInputRecords
      indexStart
      indexEnd
      addedCount
      updatedCount
      failedCount
      failureReason
      source
      expirationUnixTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDataTransferStagesQueryVariables,
  APITypes.ListDataTransferStagesQuery
>;
export const dataTransferStagesByTraceId = /* GraphQL */ `query DataTransferStagesByTraceId(
  $traceId: String!
  $sortDirection: ModelSortDirection
  $filter: ModelDataTransferStageFilterInput
  $limit: Int
  $nextToken: String
) {
  dataTransferStagesByTraceId(
    traceId: $traceId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      traceId
      fileKey
      totalInputRecords
      indexStart
      indexEnd
      addedCount
      updatedCount
      failedCount
      failureReason
      source
      expirationUnixTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DataTransferStagesByTraceIdQueryVariables,
  APITypes.DataTransferStagesByTraceIdQuery
>;
export const getExclusionRule = /* GraphQL */ `query GetExclusionRule($id: ID!) {
  getExclusionRule(id: $id) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExclusionRuleQueryVariables,
  APITypes.GetExclusionRuleQuery
>;
export const listExclusionRules = /* GraphQL */ `query ListExclusionRules(
  $filter: ModelExclusionRuleFilterInput
  $limit: Int
  $nextToken: String
) {
  listExclusionRules(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      listType
      fieldName
      excludedValues
      operator
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExclusionRulesQueryVariables,
  APITypes.ListExclusionRulesQuery
>;
export const searchExclusionRules = /* GraphQL */ `query SearchExclusionRules(
  $filter: SearchableExclusionRuleFilterInput
  $sort: [SearchableExclusionRuleSortInput]
  $limit: Int
  $nextToken: String
  $from: Int
  $aggregates: [SearchableExclusionRuleAggregationInput]
) {
  searchExclusionRules(
    filter: $filter
    sort: $sort
    limit: $limit
    nextToken: $nextToken
    from: $from
    aggregates: $aggregates
  ) {
    items {
      id
      listType
      fieldName
      excludedValues
      operator
      createdAt
      updatedAt
      __typename
    }
    nextToken
    total
    aggregateItems {
      name
      result {
        ... on SearchableAggregateScalarResult {
          value
        }
        ... on SearchableAggregateBucketResult {
          buckets {
            key
            doc_count
            __typename
          }
        }
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SearchExclusionRulesQueryVariables,
  APITypes.SearchExclusionRulesQuery
>;
